import { render, staticRenderFns } from "./deck-list.vue?vue&type=template&id=54010650&"
import script from "./deck-list.vue?vue&type=script&lang=js&"
export * from "./deck-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports